
window.addEventListener('load', () => {

    let elem = document.querySelector('.product_gallery_nav');
    let mainEle = document.querySelector('.product_gallery');

    let F = new Flickity('.product_gallery');
    F.destroy();

    let flktyMain = new Flickity( mainEle, {
        // options
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false
    });




    let gallery_items = document.querySelectorAll('.product-gallery__thumbnail');
    let showArrows = false;
    let cellAlign = 'center';
    if(gallery_items.length >= 4){
        showArrows = true;
        cellAlign = 'left';
    }

    let flkty = new Flickity( elem, {
        // options
        cellAlign: cellAlign,
        contain: true,
        asNavFor: document.querySelector('.product_gallery'),
        prevNextButtons: showArrows
    });

    let swatches = document.querySelectorAll('.swatch-element label');
    if(swatches){
        const {host, hostname, href, origin, pathname, port, protocol, search} = window.location;
        swatches.forEach((label) => {
            label.addEventListener('click', (e) => {
                document.querySelector('.sku').innerHTML = 'SKU: ' + e.target.dataset.sku;
                let price = e.currentTarget.parentNode.dataset.price;
                document.querySelector('.current_price').innerHTML = price;
                window.currencyConverter.update(document.querySelector('.current_price'));
                // let id = e.target.dataset.id;
                // window.location.href = origin + pathname + '?variant=' + id;
            })
        })
    }
})

